<template>
  <div class="c-container">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'Container',
};
</script>